module.exports = __webpack_public_path__ + "static/fonts/iconfont.16d65ed6.woff";